import React from 'react';

function EmploiPlusPage() {
  return (
    <div style={{ padding: 24 }}>
      <h1>EMPLOI+</h1>
      <p>Page `fhc-emploiplus.html` convertie en composant React.</p>
    </div>
  );
}

export default EmploiPlusPage;
